export default __webpack_public_path__ + "static/media/help-centre.ff08b059.png";